import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tourServices } from '../services/tour.service';
import toast from 'react-hot-toast';

export const useUpdateTour = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: tourServices.updateTour,
    onSuccess: (data) => {
      toast.success(data.message || 'Tour updated successfully');
      queryClient.invalidateQueries({ queryKey: ['tours'] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update tour');
    },
  });
};
